import sweepStore from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Set the SweepOptionType in sweep store
 * @param key the key as SweepOptionType to set
 * @param state the state which contains the sweep store
 */
export default action('setSweepOptionType')(select({
    sweepStore: function () { return sweepStore; },
})(function setSweepOptionType(key, state) {
    state.sweepStore.sweepOptionType = key;
}));
//# sourceMappingURL=setSweepOptionType.js.map